"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useLocaleRouter } from "@/lib/hooks/useLocaleRouter";
import { EmailVerificationBanner } from "@/components/EmailVerificationBanner";
import { BetaBanner } from "@/components/BetaBanner";
import { OfflineBanner } from "@/components/OfflineBanner";
import { FeedbackWidget } from "@/components/FeedbackWidget";
import { ToSUpdateModal } from "@/components/ToSUpdateModal";
import { WelcomeModal } from "@/components/WelcomeModal";
import { DashboardTour } from "@/components/DashboardTour";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { MobileDashboardHeader } from "@/components/dashboard/MobileDashboardHeader";
import { useAuthStore } from "@/lib/store";
import { useTranslation } from "@/lib/hooks/useTranslation";
import { users } from "@/lib/api";
export function DashboardShell(t0) {
  const $ = _c(29);
  const {
    children
  } = t0;
  const router = useLocaleRouter();
  const {
    accessToken,
    isAuthenticated,
    _hasHydrated,
    setUser
  } = useAuthStore();
  const {
    locale
  } = useTranslation();
  let t1;
  if ($[0] !== _hasHydrated || $[1] !== accessToken || $[2] !== isAuthenticated || $[3] !== router || $[4] !== setUser) {
    t1 = () => {
      if (!_hasHydrated) {
        return;
      }
      if (!isAuthenticated || !accessToken) {
        router.push("/login");
        return;
      }
      users.me(accessToken).then(userData => {
        if (userData && typeof userData === "object" && "id" in userData) {
          setUser(userData as Parameters<typeof setUser>[0]);
        }
      }).catch(_temp);
    };
    $[0] = _hasHydrated;
    $[1] = accessToken;
    $[2] = isAuthenticated;
    $[3] = router;
    $[4] = setUser;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== _hasHydrated) {
    t2 = [_hasHydrated];
    $[6] = _hasHydrated;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BetaBanner />;
    t4 = <OfflineBanner />;
    t5 = <EmailVerificationBanner />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[11] !== locale) {
    t6 = <DashboardSidebar locale={locale} />;
    $[11] = locale;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== locale) {
    t7 = <MobileDashboardHeader locale={locale} />;
    $[13] = locale;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children || $[16] !== t7) {
    t8 = <div className="flex min-w-0 flex-1 flex-col">{t7}{children}</div>;
    $[15] = children;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="flex flex-1">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  let t11;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FeedbackWidget />;
    t11 = <ToSUpdateModal />;
    t12 = <WelcomeModal />;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t10 = $[21];
    t11 = $[22];
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t9) {
    t13 = <div className="flex min-h-screen flex-col pb-[env(safe-area-inset-bottom)]">{t3}{t4}{t5}{t9}{t10}{t11}{t12}</div>;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== locale || $[27] !== t13) {
    t14 = <DashboardTour locale={locale}>{t13}</DashboardTour>;
    $[26] = locale;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}
function _temp() {}